var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobAtendimentoEsquerdo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 158,
    viewBox: "0 0 71 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3663 68.6854C53.3663 23.2233 18.0048 -4.05403 -24.4292 0.492181C-59.7908 4.12915 -73.9353 32.3157 -102.225 36.8619C-137.586 42.3174 -172.948 23.2233 -190.629 59.593C-208.309 95.9627 -194.165 136.879 -162.339 150.517C-123.441 166.884 -88.0801 141.425 -52.7184 145.971C-13.8206 150.972 45.0004 171.829 66.2174 140.006C80.3621 119.093 53.3663 91.4165 53.3663 68.6854Z",
    fill: "#3E6B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobAtendimentoEsquerdo);
export default __webpack_public_path__ + "static/media/blobAtendimentoEsquerdo.c745d784f22986d9e393e97f13f87519.svg";
export { ForwardRef as ReactComponent };